







































import {Component, Vue} from 'vue-property-decorator';
import {Getter} from 'vuex-class';
import {i18nMixin} from '@/modules/neodash/mixins';

import ReportContainer from '../../components/report-container/report-container.vue';
import FilterContainer from '../../components/filter-container/filter-container.vue';
import FormPeriod from '@/modules/neodash/components/filter-form/period-form/period-form.vue';
import {IPeriodValues, Period, PeriodFormValue} from '@/modules/neodash/model/types/interfaces/Period';
import {LocationTypeEnum} from '@/modules/neodash/model/types/enums/locationTypeEnum';
import FilterDropDown from '@/modules/neodash/components/filter-form/filter-drop-down/filterDropDown.vue';
import {NameValues} from '@/modules/neodash/model/types/interfaces/NameValue';
import ReportAppBar from '@/modules/neodash/components/report-app-bar/report-app-bar.vue';
import {IKeyValues} from '@/interfaces/key-value-interface';
import BigIconPanel from '@/modules/neodash/components/big-icon-panel/big-icon-panel.vue';
import {FilterOldService} from '@/modules/neodash/services/filterOldService';
import {GET_PERIOD} from '@/modules/neodash/store/modules/reports/types';
import {IS_AUTHORIZED} from '@/store/modules/authentication/types';

import {ReportEnum} from '@/modules/neodash/model/types/enums/reportEnum';
import {traceLogAccess} from '@/services';
import {ContextEnum} from '@/enums/context.enum';

interface LocationType {
    type: LocationTypeEnum;
    label: string;
    handler: (obj: IPeriodValues) => Promise<void>;
  }

  @Component({
    name: 'RegistrationSegmentRegion',
    components: {ReportAppBar, FilterDropDown, FormPeriod, FilterContainer, ReportContainer, BigIconPanel}
  })
  export default class RegistrationSegmentRegion extends Vue {
    public readonly translate = i18nMixin.methods.i18n;

    public readonly keyLabelLocalType: string = 'Common.LocaleType';
    public readonly keyLabelCity: string = 'Filters.LocationType.City';
    public readonly keyLabelDistrict: string = 'Common.District';
    public readonly keyLabelPMA: string = 'PMA';

    public readonly locationTypes: LocationType[] = [
      { type: LocationTypeEnum.City, label: this.keyLabelCity, handler: FilterOldService.extractProductCity },
      { type: LocationTypeEnum.District, label: this.keyLabelDistrict, handler: FilterOldService.extractProductDistrict },
      { type: LocationTypeEnum.Pma, label: this.keyLabelPMA, handler: FilterOldService.extractProductPMA }
    ];

    @Getter(GET_PERIOD)
    public getPeriod: (key: ReportEnum) => Period;

    @Getter(IS_AUTHORIZED)
    public isAuthorized: (functionality: string) => boolean;

    public chosenPeriod: PeriodFormValue = null;
    public chosenLocationType: number | null = null;

    public reportGenerated: boolean = false;
    public isDownloading: boolean = false;
    public filters: IKeyValues = [];

    public get limits(): Period {
      return this.getPeriod(ReportEnum.RegistrationSegmentRegion);
    }

    public get limitsReady(): boolean {
      const l: any = this.limits;
      return !!(l && l.initial && l.final &&
        typeof l.final.year === 'number' &&
        typeof l.final.month === 'number');
    }

    public get limitsKey(): string {
      const l: any = this.limits;
      if (!l || !l.final) return 'no-limits';
      const f = l.final;
      return `period-${f.year}-${f.month}`;
    }

    public get formValid(): boolean {
      return !!this.chosenLocationType && !this.isDownloading;
    }

    public get optionsLocationType(): NameValues {
      const locationTypes = this.isAuthorized('report-registration-segment-locale-filter-neighborhood')
        ? this.locationTypes
        : this.locationTypes.filter(x => x.type !== LocationTypeEnum.District);

      return locationTypes.map(x => ({
        name: this.translate(x.label),
        value: x.type
      }));
    }

    public get locationType(): (LocationType | null) {
      const {chosenLocationType} = this;
      if (!chosenLocationType)
        return null;

      return this.locationTypes.findOrFirst(x => x.type === chosenLocationType);
    }

    public generateReport(): void {
      const {chosenPeriod, translate, locationType, keyLabelDistrict} = this;
      if (!locationType || !chosenPeriod)
        return;

      this.reportGenerated = true;
      this.isDownloading = true;

      traceLogAccess.logAction(ContextEnum.Report, `Segmento | Modelo | Versão - Filtro`, JSON.stringify({chosenPeriod, translate, locationType, keyLabelDistrict}));
      locationType.handler(chosenPeriod.value).finally(() => {
        this.isDownloading = false;
      });
      this.updateFilters();
    }

    public resetReportGenerated(evt): void {
      this.reportGenerated = false;
    }

    private updateFilters(): void {
      const {chosenPeriod, translate, locationType, keyLabelDistrict} = this;

      if (!chosenPeriod || !locationType)
        return;

      this.filters = [
        {text: translate(keyLabelDistrict), value: translate(locationType.label)},
        {text: translate('Common.Period'), value: translate(chosenPeriod.label)}
      ];
    }
  }
